import { useEffect } from "react";
import { Loader } from "../../../components/core/Loader/Loader";
import { AuthPaths } from "../../../types/AppTypes";

const PageError401 = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === "local") {
      return;
    }
    window.location.href = `${process.env.REACT_APP_API_URL}${AuthPaths.LOGOUT}`;
  }, []);

  return <Loader loading fullscreen size={45} />;
};

export default PageError401;
